// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"0139705c","437":"0139705c","506":"0139705c","539":"a6b50f52","668":"0139705c"}[chunkId] + ".chunk.css";
};